exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrap[data-v-72f8b7b0]{width:100%;position:relative;overflow:hidden}.shim[data-v-72f8b7b0]{display:block;width:100%;position:relative;top:0;left:0}.img-pos[data-v-72f8b7b0]{position:absolute;top:0;left:0;width:100%;-webkit-transform-origin:0 0;transform-origin:0 0}.img-rotate[data-v-72f8b7b0]{position:relative;top:0;left:0;width:100%;-webkit-transform-origin:50% 50%;transform-origin:50% 50%}.img[data-v-72f8b7b0]{left:0;top:0;position:relative;width:100%;display:block}", ""]);

// exports
